export default {
  data() {
    return {
      video_width: null,
      video_height: null,
      video_frame: null,
      video_div: null,
      isVideoViewable: false,
      videoIO: null,
    };
  },
  methods: {
    removeTrackingEvent(vast_xml) {
      let vast_dom = new DOMParser().parseFromString(vast_xml, "text/xml");
      const nodeList = vast_dom.querySelectorAll(
        "Impression,TrackingEvents,ClickTracking"
      );
      for (let node of nodeList) {
        node.remove();
      }
      return new XMLSerializer().serializeToString(vast_dom);
    },
    hasFullscreenElement() {
      return (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      );
    },
    isFullscreenAvailable() {
      return (
        document.fullscreenEnabled ||
        document.mozFullscreenEnabled ||
        document.webkitFullscreenEnabled ||
        document.msFullscreenEnabled
      );
    },
    addPlayer(target, width, height) {
      let div = document.createElement("div");
      div.id = "video-div";
      let frame = document.createElement("iframe");
      frame.className = "ucfad";
      frame.src = `/preview/iframe?_type=outstream`;
      frame.frameBorder = 0;
      frame.marginheight = 0;
      frame.marginwidth = 0;
      frame.scrolling = "no";
      frame.allow = "fullscreen";
      this.setStyle(frame, {
        border: "none",
        overflow: "hidden",
        display: "block",
        "background-color": "black",
      });
      div.appendChild(frame);
      target.appendChild(div);

      this.setPlayerSize(width, height);

      this.addEvent(window, "message", this.messageHandler);
      this.addEvent(window, "visibilitychange", () => {
        if (!this.isPageHidden() && this.isVideoViewable) {
          this.onVideoPlay();
        } else {
          this.onVideoPause();
        }
      });

      this.videoIO = new IntersectionObserver(
        (entries) => {
          if (entries.length) {
            if (entries[0].isIntersecting) {
              this.isVideoViewable = true;
              this.onVideoPlay();
            } else {
              this.isVideoViewable = false;
              this.onVideoPause();
            }
          }
        },
        { threshold: 0.5 }
      );

      this.video_frame = frame;
      this.video_div = div;
    },
    initialAd(vast_xml) {
      const frame = document.querySelector(".ucfad");
      let command = {};

      command.type = "initialPlayerVastXml";
      command.width = this.video_width;
      command.height = this.video_height;
      command.vastXml = vast_xml;
      frame.contentWindow.postMessage(command, "*");
    },
    showToolBar() {
      const frame = document.querySelector(".ucfad");
      let command = {};
      command.type = "showToolBar";
      frame.contentWindow.postMessage(command, "*");
    },
    hideToolBar() {
      const frame = document.querySelector(".ucfad");
      let command = {};
      command.type = "hideToolBar";
      frame.contentWindow.postMessage(command, "*");
    },
    showSoundBtn() {
      const frame = document.querySelector(".ucfad");
      var command = {};
      command.type = "showSoundBtn";
      frame.contentWindow.postMessage(command, "*");
    },
    hideSoundBtn() {
      const frame = document.querySelector(".ucfad");
      var command = {};
      command.type = "hideSoundBtn";
      frame.contentWindow.postMessage(command, "*");
    },
    showPlayBtn() {
      const frame = document.querySelector(".ucfad");
      var command = {};
      command.type = "showPlayBtn";
      frame.contentWindow.postMessage(command, "*");
    },
    hidePlayBtn() {
      const frame = document.querySelector(".ucfad");
      var command = {};
      command.type = "hidePlayBtn";
      frame.contentWindow.postMessage(command, "*");
    },
    showProgressBar() {
      const frame = document.querySelector(".ucfad");
      var command = {};
      command.type = "showProgressBar";
      frame.contentWindow.postMessage(command, "*");
    },
    hideProgressBar() {
      const frame = document.querySelector(".ucfad");
      var command = {};
      command.type = "hideProgressBar";
      frame.contentWindow.postMessage(command, "*");
    },
    showFullScreenBtn() {
      const frame = document.querySelector(".ucfad");
      var command = {};
      command.type = "showFullscreenBtn";
      frame.contentWindow.postMessage(command, "*");
    },
    hideFullScreenBtn() {
      const frame = document.querySelector(".ucfad");
      var command = {};
      command.type = "hideFullscreenBtn";
      frame.contentWindow.postMessage(command, "*");
    },
    addVideoClickDiv() {
      const frame = document.querySelector(".ucfad");
      var command = {};
      command.type = "addClickDiv";
      frame.contentWindow.postMessage(command, "*");
    },
    removeVideoClickDiv() {
      const frame = document.querySelector(".ucfad");
      var command = {};
      command.type = "removeClickDiv";
      frame.contentWindow.postMessage(command, "*");
    },
    onVideoPlay() {
      const iframe = document.querySelector(".ucfad");
      if (iframe.contentDocument.querySelector("#ucfPlay")) return;

      let command = {};
      command.type = "play";
      iframe.contentWindow.postMessage(command, "*");
    },
    onVideoPause() {
      let command = {};
      command.type = "pause";
      document.querySelector(".ucfad").contentWindow.postMessage(command, "*");
    },
    onVideoMute() {
      let command = {};
      command.type = "sound";
      command.soundStatus = true;
      document.querySelector(".ucfad").contentWindow.postMessage(command, "*");
    },
    onVideoUnMute() {
      var command = {};
      command.type = "sound";
      command.soundStatus = false;
      document.querySelector(".ucfad").contentWindow.postMessage(command, "*");
    },
    onVideoSkip() {
      let command = {};
      command.type = "skip";
      document.querySelector(".ucfad").contentWindow.postMessage(command, "*");
    },
    onVideoClose() {
      let command = {};
      command.type = "close";
      document.querySelector(".ucfad").contentWindow.postMessage(command, "*");
    },
    setPlayerSize(width, height) {
      this.video_width = width;
      this.video_height = height;
      const frame = document.querySelector(".ucfad");
      let command = {};
      command.type = "setSize";
      command.width = width;
      command.height = height;
      frame.contentWindow.postMessage(command, "*");
      this.setStyle(frame, { width: width + "px", height: height + "px" });
    },
    setPlayerConfig() {
      let command = {};
      command.type = "setConfig";
      command.config = {
        skipDisable: true,
        ucPlayType: 2,
        hideLearnmore: true,
      };
      document.querySelector(".ucfad").contentWindow.postMessage(command, "*");
    },
  },
};
